import React from "react";
import BatteryNavbar from "./BatteryNavbar"
import BatteryHero from "./BatteryHero";
import BatteryTwo from "./BatteryTwo";
import BatteryInst from "./BatteryInst";

const BatterySwap = () => {
  return (
    <div>
      <BatteryNavbar />
      <BatteryHero />
      <BatteryTwo />
      <BatteryInst />
    </div>
  )
}

export default BatterySwap
